export async function tokenizeGGUFModel(prompt:string):Promise<number[]> {
    throw new Error('Local GGUF model tokenization is not supported in this version')
}
